import { Input } from "@sablier/v2-components/organisms";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useFieldAddress, useFieldToggle } from "../logic";

function Address() {
  const { address, isLoading, label, onBlur, onChange, onFocus } =
    useFieldAddress();
  const { t } = useT();

  return (
    <Input.Address
      id={"streamTransferFormRecipientActive"}
      isLoading={isLoading}
      info={isLoading && t("form.placeholder.resolving")}
      label={label}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={t("form.placeholder.address")}
      resolution={address.field.resolution?.short}
      value={address.field.value}
      warning={!isLoading && address.field.warning}
    />
  );
}

function Toggle() {
  const { toggle, value } = useFieldToggle();
  const { t } = useT();

  return (
    <Input.Switch
      id={toggle.field.id}
      label={{
        value: t("modalCovers.transfer.withdraw.label"),
        isIconLast: true,
      }}
      onChange={(checked) => toggle.update({ value: checked })}
      value={value}
    />
  );
}

const Fields = {
  Address,
  Toggle,
};

export default Fields;
